/* eslint-disable react/prop-types */
import React from 'react';

import { Screen } from '@confluence/screen';
import { MainLayout } from '@confluence/main-layout';
import { CALENDAR_CONTEXT } from '@confluence/team-calendar/entry-points/TeamCalendars';

import { LazyTeamCalendars } from '../lazyComponents';

export function MyCalendarRoute({ spaceKey }) {
	return (
		<Screen screenEvent={{ name: 'myCalendarsScreen', id: spaceKey }} pageState={{ spaceKey }}>
			<MainLayout spaceKey={spaceKey}>
				<LazyTeamCalendars calendarContext={CALENDAR_CONTEXT.MY_CALENDARS} />
			</MainLayout>
		</Screen>
	);
}
